/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchPccDemographicsResponse
 */
export interface PatchPccDemographicsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PatchPccDemographicsResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchPccDemographicsResponse
     */
    demographic_warnings?: Array<string>;
}

/**
 * Check if a given object implements the PatchPccDemographicsResponse interface.
 */
export function instanceOfPatchPccDemographicsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchPccDemographicsResponseFromJSON(json: any): PatchPccDemographicsResponse {
    return PatchPccDemographicsResponseFromJSONTyped(json, false);
}

export function PatchPccDemographicsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchPccDemographicsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
        'demographic_warnings': !exists(json, 'demographic_warnings') ? undefined : json['demographic_warnings'],
    };
}

export function PatchPccDemographicsResponseToJSON(value?: PatchPccDemographicsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'demographic_warnings': value.demographic_warnings,
    };
}

